/**
 * Shimmer effect for skeleton loading states.
 * Renders a sweeping highlight animation over a placeholder element.
 *
 * Usage:
 *   <Shimmer className="h-4 w-3/4 bg-background rounded-lg" />
 */
const Shimmer = ({ className = '' }) => (
  <div className={`relative overflow-hidden ${className}`}>
    <div className="absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-content-inverse/40 to-transparent" />
  </div>
);

export default Shimmer;
